import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4621ab54")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Cliente ")
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-2" }, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-my-2"
}
const _hoisted_7 = { class: "p-text-center" }
const _hoisted_8 = { class: "p-d-flex p-jc-between p-mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Nuovo cliente", -1)
const _hoisted_11 = { class: "actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!
  const _component_CustomerSummary = _resolveComponent("CustomerSummary")!
  const _component_CustomerForm = _resolveComponent("CustomerForm")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_AutoComplete, {
            ref: "autocompleteRef",
            modelValue: _ctx.searchBox,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
            minLength: 1,
            suggestions: _ctx.suggestions,
            completeOnFocus: "",
            field: "business_name",
            placeholder: "Cerca cliente per nome, cognome o email",
            onComplete: _ctx.search,
            onItemSelect: _ctx.onSelect,
            onKeyup: _withKeys(_ctx.onEnter, ["enter"])
          }, {
            item: _withCtx(({item}) => [
              _hoisted_4,
              _createElementVNode("strong", null, _toDisplayString(item.business_name), 1),
              (item.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - " + _toDisplayString(item.name), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onKeyup"]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-plus",
            label: "Nuovo",
            onClick: _ctx.toggleSidebar
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('new'),
              void 0,
              { bottom: true }
            ]
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Message, {
            class: "p-text-center",
            severity: "error"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.selected)
      ? (_openBlock(), _createBlock(_component_CustomerSummary, {
          key: 1,
          customer: _ctx.selected
        }, null, 8, ["customer"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Button, {
        disabled: !_ctx.isValid,
        icon: "pi pi-chevron-right",
        label: "Avanti",
        onClick: _ctx.goNext
      }, null, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_Sidebar, {
      visible: _ctx.displayNewCustomer,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayNewCustomer = $event)),
      class: "p-sidebar-lg custom_sidebar",
      header: "Nuovo cliente",
      position: "right"
    }, {
      default: _withCtx(() => [
        _hoisted_10,
        (_ctx.showError)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              ref: "msg",
              life: 3000,
              sticky: false,
              severity: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('validation.form_generic')), 1)
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true),
        _createVNode(_component_CustomerForm, {
          customer: _ctx.newCustomer,
          onSave: _ctx.onSave
        }, null, 8, ["customer", "onSave"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            label: _ctx.$t('cancel'),
            class: "p-button-secondary",
            icon: "pi pi-times",
            onClick: _ctx.toggleSidebar
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.$t('common.save'),
            form: "customer-form",
            icon: "pi pi-save",
            type: "submit"
          }, null, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}